module.exports = __webpack_public_path__ + "img/worker.3c2d1c97.png";